{
  "overview": {
    "pageTitle": "Sortimentadministrasjon",
    "cardTitle": "Sortimentliste",
    "manageButton": "Administrer sortimenter",
    "searchPlaceholder": "Søk etter sortiment...",
    "searchAriaLabel": "Søk etter sortiment",
    "filter": {
      "treeSpeciesLabel": "Treslag",
      "treeSpeciesAll": "Alle treslag",
      "groupLabel": "Gruppe",
      "groupAll": "Alle grupper",
      "typeLabel": "Type",
      "typeAll": "Alle typer",
      "searchPlaceholder": "Søk i filtervalg",
      "noResults": "Ingen treff",
      "reset": "Nullstill"
    },
    "countLabel": "Viser {{visible}} av {{total}} sortimenter",
    "pagination": {
      "rowsPerPage": "Rader per side",
      "all": "Alle",
      "previousPage": "Forrige side",
      "nextPage": "Neste side"
    },
    "table": {
      "ariaLabel": "Sortimentliste",
      "loading": "Laster sortimenter...",
      "emptyTitle": "Ingen sortimenter funnet",
      "emptyDescription": "Det finnes ingen sortimenter å vise akkurat nå.",
      "errorTitle": "Kunne ikke laste sortimenter",
      "errorDescription": "Det oppstod en feil under henting av sortimenter. Prøv igjen.",
      "columns": {
        "number": "Nr",
        "name": "Sortimentnavn",
        "treeSpecies": "Treslag",
        "group": "Gruppe",
        "type": "Type",
        "actions": "Handlinger"
      },
      "rowActionsAriaLabel": "Flere handlinger for {{assortmentName}}",
      "actions": {
        "editType": "Endre sortimentstype"
      },
      "deactivatedBadge": "Deaktivert"
    },
    "editTypeDialog": {
      "title": "Endre sortimentstype på {{identifier}} - {{name}}",
      "typeField": {
        "label": "Sortimentstype",
        "placeholder": "Velg sortimentstype",
        "searchPlaceholder": "Søk etter sortimentstype",
        "noResults": "Ingen treff"
      },
      "saveError": "Noe gikk galt. Prøv igjen."
    }
  },
  "sync": {
    "menuOption": "Oppdater sortimentsliste fra Skogdata",
    "menuAriaLabel": "Flere handlinger for sortimentadministrasjon",
    "alreadyRunningMessage": "En oppdatering er allerede i gang. Vent til den er ferdig før du prøver igjen.",
    "inProgressDialog": {
      "title": "Sortimentlisten oppdateres",
      "description": "Oppdateringen kan ta noen minutter. Last siden på nytt etter en liten stund for å se de siste endringene.",
      "closeButton": "Lukk"
    },
    "lastUpdated": "Sist oppdatert {{date}} kl. {{time}}"
  },
  "search": {
    "cardTitle": "Sortimentliste",
    "searchInputLabel": "Søk etter sortiment",
    "searchButton": "Søk",
    "readyDescription": "Bruk søkefeltet for å finne sortimenter."
  },
  "types": {
    "pageTitle": "Endre sortimentstyper",
    "backLink": "Tilbake til sortimentadministrasjon",
    "cardTitle": "Sortimentstyper",
    "cardDescription": "Opprett nye sortimentstyper eller endre de eksisterende",
    "addButton": "Legg til sortimentstype",
    "filter": {
      "reset": "Nullstill",
      "searchPlaceholder": "Søk i filtervalg",
      "noResults": "Ingen treff"
    },
    "table": {
      "ariaLabel": "Sortimentstyper",
      "loading": "Laster sortimentstyper...",
      "emptyTitle": "Ingen sortimentstyper",
      "emptyDescription": "Velg 'Legg til sortimentstype' for å opprette en ny",
      "errorTitle": "Kunne ikke laste sortimentstyper",
      "errorDescription": "Det oppstod en feil under henting av sortimentstyper. Prøv igjen.",
      "columns": {
        "name": "Navn",
        "actions": "Handlinger"
      },
      "rowActionsAriaLabel": "Flere handlinger for {{name}}",
      "renameAction": "Endre navn",
      "deleteAction": "Slett"
    },
    "addDialog": {
      "title": "Legg til sortimentstype",
      "namePlaceholder": "Gi sortimentstypen et navn",
      "saveButton": "Lagre sortiment"
    },
    "editDialog": {
      "title": "Endre navn",
      "description": "Gi sortimentstypen et nytt navn",
      "namePlaceholder": "Gi sortimentstypen et nytt navn",
      "saveButton": "Lagre endring"
    },
    "duplicateNameError": "Sortimentstypen finnes allerede",
    "deleteDialog": {
      "title": "Er du sikker på at du vil slette {{name}}?",
      "linkedDescription": "{{count}} sortimenter bruker denne og vil mangle sortimentstype",
      "cancelButton": "Avbryt",
      "confirmButton": "Slett"
    },
    "entryModal": {
      "manageTypesOption": "Endre sortimentstyper",
      "closeButton": "Lukk"
    }
  }
}
